import { ActionReducerMap, MetaReducer } from '@ngrx/store';
// import { storeLogger } from 'ngrx-store-logger';

// export function logger(reducer: ActionReducer<any>): any {
//   return storeLogger()(reducer);
// }

/**
 * Our state is composed of a map of action reducer functions.
 * These reducer functions are called with each dispatched action
 * and the current or initial state and return a new immutable state.
 */
export const reducers: ActionReducerMap<any> = {};

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
export const metaReducers: MetaReducer<any>[] = [/*logger*/];
